import type { SVGProps } from 'react';
const SvgArrowRightAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#arrow_right_alt_svg__a)">
      <path fill="currentColor" d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3Z" />
    </g>
    <defs>
      <clipPath id="arrow_right_alt_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgArrowRightAlt;
